import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { combineLatest } from 'rxjs';
import { CustomerService } from 'src/app/services/customer.service';
import { faEdit, faTrashAlt, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { CustomerFilter } from 'src/app/common/CustomerFilter';
import { AppProfileService } from 'src/app/services/profile.service';
import { ExtendedProfile } from 'src/app/common/ExtendedProfile';
import { AuthorizeService } from 'src/app/auth/authorize.service';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { PagedList } from 'src/app/common/PagedList';
import { Customer } from 'src/app/common/Customer';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CustomerSearchBoxComponent } from '../customer-search-box/customer-search-box.component';
import { GridPdfColumnsDirective } from '../grid/grid-pdf-columns.directive';
import { PdfPageComponent } from '../grid/pdf-page.component';
import { GridNoRecordsComponent } from '../grid/grid-no-records.component';


@Component({
    imports: [KENDO_GRID, FontAwesomeModule, CustomerSearchBoxComponent, GridPdfColumnsDirective, PdfPageComponent, GridNoRecordsComponent],
    selector: 'app-customer',
    templateUrl: './customer-list.component.html',
    styleUrls: ['./customer-list.component.css']
})
export class CustomerListComponent implements OnInit {
  customerService = inject(CustomerService);
  private router = inject(Router);
  private profileService = inject(AppProfileService);
  private authService = inject(AuthorizeService);

  private destroyRef = inject(DestroyRef);

  public faEdit = faEdit;
  public faTrashAlt = faTrashAlt;
  public faFilePdf = faFilePdf;
  public filter: CustomerFilter = new CustomerFilter('', null);
  public profile: ExtendedProfile;
  public tenantMode: boolean;

  // #648: server-side paging/sorting. Only whitelist-backed columns are server-sortable; the
  // backend default order is customerNumber ascending. Only a carrier sees customers.
  public list = new PagedList<Customer>({
    sortFields: { lastName: 'lastName' },
    fetch: (paging) =>
      this.profile?.isCarrier && this.filter
        ? this.customerService.getByfilter(this.filter.name, this.filter.customerGroupId, paging)
        : null,
  });

  public ngOnInit() {
    // One search per change of either, starting with the first values — this used to fire twice
    // on init (the retailer-mode callback and a trailing explicit call).
    combineLatest([this.profileService.currentProfile$, this.authService.$retailerMode])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([profile, tenantMode]) => {
        this.profile = profile;
        this.tenantMode = tenantMode;
        this.list.search();
      });
  }

  public search(filter: CustomerFilter) {
    this.filter = filter;
    this.list.search();
  }

  public onEdit(customerId: string) {
    if (this.profile.isCarrier) {
      this.router.navigate(['/customer-edit/' + customerId]);
    }
  }
}
